
<template>
    <div class="slider8">
        <div class="title position-absolute d-flex justify-content-center align-items-center">
            <div v-for="item in tabList" :key="item.id" class="tab-txt cursor"
                :class="active === item.id ? 'active-txt' : ''" @click="handleTab(item)">
                {{ item.txt }}
            </div>
        </div>
        <div class="cnt" v-if="activeFlag">
            <swiper :options="options" ref="videoSwiper">
                <swiper-slide v-for="item in list" :key="item.id">
                    <div class="position-relative video-cnt">
                        <iframe width="100%" height="100%" :src="item.videoUrl" title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination-media"></div>
        </div>
        <!-- 艺人图片轮播 -->
        <div class="yrImg" v-else>
            <swiper :options="yrOptions" ref="YRswiper">
                <swiper-slide v-for="(yrItem, index) in yrImgList" :key="(index + 1)">
                    <div class="position-relative video-cnt">
                        <img :src="yrItem" alt="" srcset="">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination-media"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: 1,
            tabList: [
                {
                    id: 1,
                    txt: '비디오'
                },
                {
                    id: 2,
                    txt: '갤러리'
                },
            ],
            list: [
                {
                    id: 1,
                 
                    videoUrl: 'https://www.youtube.com/embed/wHQiH_3gt1I?si=UWSLgWKhyY2f2NKP'

                },
                {
                    id: 2,
                    videoUrl: 'https://www.youtube.com/embed/kT9CsJaEFig?si=OeIyy6JOisloNAPX" title="YouTube video player'
                },
                {
                    id: 3,
                    videoUrl: 'https://www.youtube.com/embed/PCoonhHBRJw?si=zJe0eWkOsN1lpobB'
                }, {
                    id: 4,
                    videoUrl: 'https://www.youtube.com/embed/HQ7a_EG2U5g?si=g3UYZH2zLfwaxbkX&amp;controls=0'
                },

            ],
            yrImgList: [
                require('../../assets/img/m8/vd-1.png'),
                require('../../assets/img/m8/vd-2.png'),
                require('../../assets/img/m8/vd-3.png'),
                require('../../assets/img/m8/vd-4.png'),
                require('../../assets/img/m8/vd-5.png'),
                require('../../assets/img/m8/vd-6.png'),
                require('../../assets/img/m8/vd-7.png'),
                require('../../assets/img/m8/vd-8.png'),
                require('../../assets/img/m8/vd-9.png'),
                require('../../assets/img/m8/vd-10.png'),
                require('../../assets/img/m8/vd-11.png'),
                require('../../assets/img/m8/vd-12.png'),
                require('../../assets/img/m8/vd-13.png'),
                require('../../assets/img/m8/vd-14.png'),
                require('../../assets/img/m8/vd-15.png'),
                require('../../assets/img/m8/vd-16.png'),
                require('../../assets/img/m8/vd-17.png'),
                require('../../assets/img/m8/vd-18.png'),
                require('../../assets/img/m8/vd-19.png'),
                require('../../assets/img/m8/vd-20.png'),
                require('../../assets/img/m8/vd-21.png'),
            ],
            options: {
                grabCursor: true, //在轮播图上显示小手
                speed: 1000,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination-media',
                    clickable: true,
                    bulletClass: 'custom-bullet',
                    bulletActiveClass: 'custom-bullet-active'
                },
            },
            yrOptions: {
                grabCursor: true, //在轮播图上显示小手
                speed: 1000,
                navigation: {
                    nextEl: '.yr-swiper-button-next',
                    prevEl: '.yr-swiper-button-prev'
                },
                pagination: {
                    el: '.yr-swiper-pagination-media',
                    clickable: true,
                    bulletClass: 'custom-bullet',
                    bulletActiveClass: 'custom-bullet-active'
                },
            },

            activeFlag: true
        }
    },
    methods: {
        handleTab(item) {
            this.active = item.id
            if (item.id === 1) {
                this.activeFlag = true
            } else {
                this.activeFlag = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/* 外层容器 */
.slider8 {
    background: url("../../assets/img/m8/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;

    .title {
        width: 1056px;
        height: 74px;
        border-top: 4px solid #fff;
        border-bottom: 4px solid #fff;
        top: 135px;
        left: 50%;
        transform: translate(-50%, 0);

        .tab-txt {
            font-family: ONEMobileTitleRegular;
            font-size: 39px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
            font-weight: bold;
            width: 468px;
            height: 74px;
            line-height: 74px;
            text-align: center;
        }

        .active-txt {
            background-color: #ffffff;
            color: #000;
        }
    }

    .cnt,
    .yrImg {

        width: 976px;
        position: absolute;
        transform: translate(-50%, 0);
        top: 245px;
        left: 50%;

        .video-cnt {
            width: 976px;
            height: 550px;

            .video-bg {
                position: absolute;
                left: 50%;
                top: 50%;
                /*保证视频内容始终居中*/
                transform: translate(-50%, -50%);
                width: 100%;
                height: 100%;
                /*保证视频充满屏幕*/
                object-fit: cover;

                video {}
            }
        }

        .img-size {
            width: 976px;
            height: 550px;
            display: block;
        }

        .swiper-button-prev:after {
            display: none;
        }

        .swiper-button-next:after {
            display: none;
        }

        .swiper-button-prev {
            background: url("../../assets/img/m8/prev.png") no-repeat top;
            background-size: cover;
            width: 25px;
            height: 25px;
            bottom: -45px;
            top: auto;
            left: 150px;

        }

        .swiper-button-next {
            background: url("../../assets/img/m8/next.png") no-repeat top;
            background-size: cover;
            width: 25px;
            height: 25px;
            bottom: -45px;
            top: auto;
            right: 150px;
        }

        /deep/ .swiper-pagination-media {
            position: absolute;
            bottom: -35px;
            display: flex;
            justify-content: center;
            gap: 17px;
            left: 50%;
            transform: translateX(-50%);

            .custom-bullet {
                display: inline-block;
                width: 10px;
                height: 10px;
                background-color: #d4d4d4;
                cursor: pointer;
                border-radius: 50%;
            }

            .custom-bullet-active {
                width: 26px;
                height: 10px;
                background-color: #ffffff;
                border-radius: 3px;
            }
        }

    }



}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .slider8 {
        .title {
            top: 100px !important;
            width:845px !important;
        height: 60px !important;
        .tab-txt{
            width: 375px !important;
            height: 60px !important;
            line-height: 60px !important;
        }
        }

        .cnt,
        .yrImg {
            top: 200px !important;
            width: 780px !important;
            .video-cnt {
                width: 780px !important;
                height: 440px !important;
            }

            .swiper-button-prev {
                left: 60px !important;
            }
            .swiper-button-next {
                right: 60px !important;
            }
        }
        .yrImg img{
            width: 100%;
        }

    }


}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider8.vue